export default function CTASection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-16">
        <div className="mx-auto max-w-[1100px]">
          <div className="w-full h-[300px] md:h-[420px] rounded-2xl overflow-hidden relative">
            <img
              src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20flat%20lay%20photography%20of%20contemporary%20fashion%20essentials%20including%20folded%20linen%20shirts%20a%20straw%20hat%20leather%20sandals%20and%20a%20woven%20bag%20arranged%20in%20a%20perfect%20grid%20on%20a%20textured%20natural%20linen%20backdrop%20with%20warm%20golden%20hour%20sunlight%20and%20subtle%20film%20grain%20texture%20European%20summer%20editorial%20aesthetic&width=1400&height=640&seq=cta-collage-v2&orientation=landscape"
              alt="OOPBuy Spreadsheet curated collection"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/15" />
          </div>
          <div className="text-center mt-16">
            <p className="font-heading text-3xl md:text-4xl lg:text-[40px] leading-snug text-foreground-950 font-bold">Stop searching.</p>
            <p className="font-heading text-3xl md:text-4xl lg:text-[40px] leading-snug text-foreground-400 font-light italic">
              Start <em className="not-italic font-normal text-foreground-950">sourcing.</em>
            </p>
            <p className="font-heading text-3xl md:text-4xl lg:text-[40px] leading-snug text-foreground-950 font-bold">With OOPBuy.</p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center w-[220px] h-14 rounded-full bg-primary-500 text-background-50 font-semibold text-base mt-10 whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}